import script from "./ProjectLogs.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectLogs.vue?vue&type=script&setup=true&lang=js"

import "./ProjectLogs.vue?vue&type=style&index=0&id=733f4ae7&scoped=true&lang=css"

import exportComponent from "H:\\project\\tako\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-733f4ae7"]])

export default __exports__